import React from 'react';
import Home from '../views/Home';
import Finish from '../views/Finish';
import CheckInStep1 from '../views/CheckInStep1';
import CheckInStep2 from '../views/CheckInStep2';
import CheckInLogin from '../views/CheckInLogin';

const routes = [
  {
    path: "/",
    element: <Home />,
    isLogged: false,
  },
  {
    path: "/login",
    element: <CheckInLogin />,
    isLogged: false,

  },
  {
    path: "/step-1",
    element: <CheckInStep1 />,
    isLogged: true,

  },
  {
    path: "/step-2",
    element: <CheckInStep2 />,
    isLogged: true,

  },
  {
    path: "/finish",
    element: <Finish />,
    isLogged: true,

  },
  {
  	path: "*",
  	element: <Home />,
    isLogged: false,
  },
];

export default routes;
